import type { Position } from '@retejs/lit-plugin';
import { css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('white-connection')
export class WhiteConnectionElement extends LitElement {
  static get properties() {
    return {
      start: { type: Object },
      end: { type: Object },
      path: { type: String },
      connection: { type: Object },
      selected: { type: Boolean },
    };
  }

  declare start: Position;
  declare end: Position;
  declare path: string;
  declare connection?: unknown;
  declare selected: boolean;

  constructor() {
    super();
    this.selected = false;
  }

  static styles = css`
    svg {
      overflow: visible !important;
      position: absolute;
      pointer-events: none;
      width: 9999px;
      height: 9999px;
    }

    path {
      fill: none;
    }

    path.hit-area {
      stroke: transparent;
      stroke-width: 12px;
      pointer-events: stroke;
      cursor: pointer;
    }

    path.line {
      stroke-width: 2px;
      stroke: var(--color-connection-stroke);
      pointer-events: none;
      transition:
        stroke 0.2s ease,
        stroke-width 0.2s ease;
    }

    path.hit-area:hover + path.line {
      stroke: var(--color-connection-stroke);
      stroke-width: 2.5px;
    }

    path.line.selected {
      stroke: var(--color-connection-stroke);
      stroke-width: 3px;
    }
  `;

  render() {
    return html`
      <svg data-testid="connection">
        <path
          d=${this.path}
          class=${`hit-area ${this.selected ? 'selected' : ''}`}
        ></path>
        <path d=${this.path} class=${`line ${this.selected ? 'selected' : ''}`}></path>
      </svg>
    `;
  }
}
